import ListsSectionLoader from "./ListsSectionLoader";
import { StyledLoadersWrapper } from "./styles";

const ListSectionLoaders = () => {
    return (
        <StyledLoadersWrapper>
            <ListsSectionLoader />
            <ListsSectionLoader />
        </StyledLoadersWrapper>
    );
};

export default ListSectionLoaders;
